import type { DealInsightsApi } from '@openx/types/dealInsights.ts';

export const dealInsightsDefaultDataApi: DealInsightsApi = {
  general_stats: {
    impressions: { value: null, percentage_change: null },
    spend: { value: null, percentage_change: null },
    ecpm: { value: null, percentage_change: null },
    bid_rate: { value: null, percentage_change: null },
    win_rate: { value: null, percentage_change: null },
    viewability: { value: null, percentage_change: null },
    vcr: { value: null, percentage_change: null },
    ctr: { value: null, percentage_change: null },
    iqs_on_impression: { value: null, percentage_change: null },
    previous_period_calculated: true,
  },
  spend: [],
  bidrate_winrate: [],
  inventory_distributions: {
    directness: {
      spend: {
        true: null,
        false: null,
      },
      impressions: {
        true: null,
        false: null,
      },
      clicks: {
        true: null,
        false: null,
      },
    },
    dsp_name: {
      impressions: {},
      spend: {},
      clicks: {},
    },
    channel: {
      spend: {
        site: null,
        app: null,
      },
      impressions: {
        site: null,
        app: null,
      },
      clicks: {
        site: null,
        app: null,
      },
    },
    media_type: {
      spend: {
        ctv: null,
        olv: null,
        display: null,
      },
      impressions: {
        ctv: null,
        olv: null,
        display: null,
      },
      clicks: {
        ctv: null,
        olv: null,
        display: null,
      },
    },
  },
  delivery_by_domain_bundle: {
    total_rows: 0,
    impressions_range: {
      minimum: null,
      maximum: null,
    },
    spend_range: {
      minimum: null,
      maximum: null,
    },
    sov_range: {
      minimum: null,
      maximum: null,
    },
    ecpm_range: {
      minimum: null,
      maximum: null,
    },
    clicks_range: {
      minimum: null,
      maximum: null,
    },
    ctr_range: {
      minimum: null,
      maximum: null,
    },
    vcr_range: {
      minimum: null,
      maximum: null,
    },
    viewability_range: {
      minimum: null,
      maximum: null,
    },
    objects: [],
  },
  delivery_by_ad_size: {
    total_rows: 0,
    impressions_range: {
      minimum: null,
      maximum: null,
    },
    spend_range: {
      minimum: null,
      maximum: null,
    },
    sov_range: {
      minimum: null,
      maximum: null,
    },
    ecpm_range: {
      minimum: null,
      maximum: null,
    },
    clicks_range: {
      minimum: null,
      maximum: null,
    },
    ctr_range: {
      minimum: null,
      maximum: null,
    },
    viewability_range: {
      minimum: null,
      maximum: null,
    },
    objects: [],
  },
  delivery_by_ad_duration: {
    total_rows: 0,
    impressions_range: {
      minimum: null,
      maximum: null,
    },
    spend_range: {
      minimum: null,
      maximum: null,
    },
    clicks_range: {
      minimum: null,
      maximum: null,
    },
    ctr_range: {
      minimum: null,
      maximum: null,
    },
    ecpm_range: {
      minimum: null,
      maximum: null,
    },
    sov_range: {
      minimum: null,
      maximum: null,
    },
    objects: [],
  },

  audiences: {
    total_rows: 0,
    spend_range: {
      minimum: null,
      maximum: null,
    },
    impressions_range: {
      minimum: null,
      maximum: null,
    },
    uniques_range: {
      minimum: null,
      maximum: null,
    },
    avg_frequency_range: {
      minimum: null,
      maximum: null,
    },
    viewability_range: {
      minimum: null,
      maximum: null,
    },
    objects: [],
  },
  geolocation: {
    country: {
      spend: {},
      impressions: {},
      clicks: {},
    },
    us_state: {
      spend: {},
      impressions: {},
      clicks: {},
    },
  },
  deal_stats: {
    total_rows: 0,
    impressions_range: {
      minimum: null,
      maximum: null,
    },
    spend_range: {
      minimum: null,
      maximum: null,
    },
    ctr_range: {
      minimum: null,
      maximum: null,
    },
    ecpm_range: {
      minimum: null,
      maximum: null,
    },
    objects: [],
  },
};
